/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowForward16: {
  name: 'arrow-forward-16';
  data: string;
} = {
  name: 'arrow-forward-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 5.125V4a1 1 0 0 1 1.556-.832l5.999 4a1 1 0 0 1 0 1.664l-6 4A1 1 0 0 1 8 12v-1.129c-.231-1.467-4.455-1.223-6.43.877-.474.466-1.09.208-1.4-.19a.777.777 0 0 1-.03-.932C1.665 8.39 3.995 6.76 7 6c.506 0 .93-.434 1-.875z"/></svg>`
};
